require('../../modules/es.typed-array.iterator');
